import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useMeasuresAndDimensions, useCreateColFunds } from "./insFundsDataExportGrid.setup";
import { prepareTagRows } from "components/tags/helpers";
import { useFetchTagsQuery } from "components/tags/tagsApi";
import { TagEntityType } from "components/tags/types";
import { InsGrid } from "components/widgets";
import { insDatapointGridWidgetAdapterData } from "components/widgets/grid/insDatapointGridWidgetAdapter";
import { useCustomDataDatapointsRequest, useGetCustomDataDatapoints } from "hooks/use-custom-data-datapoints";
import { gridCurrencySelector, setSelectedRowsState } from "store/grids";
export const InsFundsDataExportGrid = (props) => {
    const dispatch = useDispatch();
    const currency = useSelector((s) => gridCurrencySelector(s, props.stateId));
    const { dimensions, measures } = useMeasuresAndDimensions(currency, []);
    const request = useCustomDataDatapointsRequest(dimensions, measures, props.stateId, currency), [data, querystate] = useGetCustomDataDatapoints(request);
    const cols = useCreateColFunds();
    const { rows, totals } = insDatapointGridWidgetAdapterData(data, cols);
    const { data: tags } = useFetchTagsQuery({ entityType: TagEntityType.FUND });
    const newRows = prepareTagRows(rows, tags);
    return React.createElement(React.Fragment, null,
        React.createElement(InsGrid, { selectionMode: "multiple", rowSelectedHandler: ((e) => {
                dispatch(setSelectedRowsState({
                    id: props.stateId,
                    selectedRows: e.api.getSelectedRows()
                        .map((row) => `${row.Id}`)
                }));
            }), widgetId: props.stateId, stateId: props.stateId, columnDefs: cols, rowData: newRows, totalData: totals, queryState: querystate, suppressRowClickSelection: true }));
};
